import { render, staticRenderFns } from "./bind-login.vue?vue&type=template&id=414591c2&"
import script from "@/model/bindlogin?vue&type=script&lang=js&"
export * from "@/model/bindlogin?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports